
/* Name:Chaitali Khachane
   Description:this page contain all the component(with their css) required for home page */

   import styled from "styled-components";

   export const LabelText = styled.span`
   // font-family: Mars Centra;
   font-size: 30px;
   font-weight: 500;
   // line-height: 90px;
   // position:fixed;
   color:#ffffff;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   margin-top: 10%;
   margin-left: 50px;
   // gap: 32px;
   // opacity: 0px;
   
   
   `
   export const LabelSubText = styled.span`
   // font-family: Mars Centra;
   font-size: 15px;
   font-weight: 500;
   // line-height: 90px;
   // position:fixed;
   color:#ffffff;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   // margin-top: 15%;
   margin-left: 50px;
   // gap: 32px;
   // opacity: 0px;
   
   
   `
   export const HomeContainer = styled.div`
   backdropFilter: blur(10px);
   border-radius:45px;
   margin:40px 28px;
   position:relative;
   height:90%;
   // background: rgb(9,0,160);
   // background: #fff
   background: linear-gradient(90deg, rgba(9,0,160,1) 54%, rgba(0,212,255,1) 100%);
   overflow:hidden;
   `
   export const CurtainStyle = styled.div`
       border-radius: 0 0 45px 0;
    //    position:fixed;
       top:40px;
       width: 100%;
       height: 100%;
       background: rgb(9,0,160);
       // background: linear-gradient(90deg, rgba(9,0,160,1) 54%, rgba(0,212,255,1) 100%);
       backgroundColor: rgb(9,0,160); // Transparent white background
       backdropFilter: blur(10px); // Apply blur to the background
       // border: 1px solid rgba(255, 255, 255, 0.2); // Subtle border for a glass effect
       boxShadow: 0 4px 6px rgba(0, 0, 0, 0.1); // Shadow for depth
       // position: relative;// To position the "curtain"
       overflow: hidden; // Hide anything outside the container
   `
   
   export const StripedOverlayStyle = styled.div`
   
       width: 100%;
       height: 100%;
    //    border-radius:45px;
       background: repeating-linear-gradient(90deg,rgba(59, 59, 59, 0.2)   0%, rgba(255, 255, 255, 0) 6.67%, rgba(255, 255, 255, 0) 10%);
       backgroundBlendMode: overlay;
       backdropFilter: "blur(100px)";
   `
   export const DisplayData = styled.div`
       z-index: 2;
       width: 100%;
       height: 56.1%;
    //    bottom: 9px;
    //    right: 28px;
       gap: 0px;
       border-radius: 70px 53px 0px -0px;
       background: rgb(255, 255, 255);
       margin-top:34.4%;
       position: relative;
       padding:15px;
   `
   export const DisplayDataHeading = styled.div`
     font-family: Mars Centra;
     padding-left:5%;
     padding-top:0%;
   font-size: 16px;
   font-weight: 700;
   // line-height: 20.8px;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   color: #0000A0;
   
   `
   export const ImageContainer = styled.div`
       background: linear-gradient(90deg, rgba(9,0,160,1) 54%, rgba(0,212,255,1) 100%);
   
   `
   export const ActiveDataCard = styled.div`
//    position: absolute;
       width: 100%;
       height: 95%;
       bottom: 40px;
       // left: 30px;
       gap: 10px;
       border-radius: 15px;
       background: rgba(255, 255, 255, 0.2);
       border-width: 3px;
       border-style: solid;
       border-color: initial;
       border-image-slice: initial;
       border-image-width: initial;
       border-image-outset: initial;
       border-image-repeat: initial;
       border-image-source: linear-gradient(286.11deg, rgba(255, 255, 255, 0) -1.71%, rgba(0, 215, 185, 0.6) 41.68%, rgba(255, 255, 255, 0) 101.61%);
       backdrop-filter: blur(20px);
       padding:15px;
   `
   export const NonActiveDataCard = styled.div`
   padding:15px;
//    position: absolute;
       width: 100%;
       height: 80%;
       bottom: 40px;
       // left: 50%;
       gap: 10px;
       border-radius: 15px;
       background: rgba(255, 255, 255, 0.2);
       border-width: 3px;
       border-style: solid;
       border-color: initial;
       border-image-slice: initial;
       border-image-width: initial;
       border-image-outset: initial;
       border-image-repeat: initial;
       border-image-source: linear-gradient(286.11deg, rgba(255, 255, 255, 0) -1.71%, rgba(0, 215, 185, 0.6) 41.68%, rgba(255, 255, 255, 0) 101.61%);
       backdrop-filter: blur(20px);
   `
   export const DataCardHeading = styled.div`
   color:#fff;
   font-family: Mars Centra;
   font-size: 18px;
   font-weight: 700;
   // line-height: 31.2px;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   margin-bottom:10px;
   `
   export const DataCardValue = styled.div`
   color:#fff;
   font-family: Mars Centra;
   font-size: 12px;
   // font-weight: 400;
   // line-height: 26px;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   `
   
   export const NavPage = styled.div`
   position:absolute;
   bottom:0;
   right:4px;
   font-family: Mars Centra;
   font-size: 12px;
   // font-weight: 700;
   line-height: 20.8px;
   text-align: right;
   text-decoration-line: underline;
   text-decoration-style: solid;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   color: #FFFFFF;
   `
   export const DataDisplayCard = styled.div`
   
   padding: 3px 5px 27px 5px;
   gap: 0px;
   border-radius: 40px;
   border: 1px 0px 0px 0px;
   opacity: 0px;
   
   height:95%;
   background: #FFFFFF;
   border: 1px solid #0000001A;
   `
   export const DataDisplayCardHeader=styled.span`
   width: calc(100% - 55px);
   display: inline-block;
   overflow:hidden;
   font-family: Mars Centra;
   font-size: 12px;
   font-weight: 700;
   // line-height: 15.6px;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   margin-top:5px;
   
   `
   export const DataDisplayCardValue=styled.div`
   font-family: Mars Centra;
   font-size: 11px;
   font-weight: 400;
   line-height: 14.3px;
   text-align: left;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   color: #727272;
   margin-top:5px;
   
   `
   export const DataDisplayCardNav=styled.div`
   font-family: Mars Centra;
   font-size: 10px;
   font-weight: 700;
   line-height: 13px;
   text-align: right;
   text-decoration-line: underline;
   text-decoration-style: solid;
   text-underline-position: from-font;
   text-decoration-skip-ink: none;
   color: #0000A0;
   
   `